module.exports = __webpack_public_path__ + "static/HouseIndustry-6e8d6ba3956a137f53790b8655611d7b.jpg";